import * as React from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { DateSection } from './DateSection';
import { CameraTreeSection } from './CameraTreeSection';
import { AlarmListSection } from './AlarmListSection';
import { VerticalSplitView } from 'ui/shared/SplitView';
import { persist } from 'ui/shared/persist';
import { State } from 'reducers';
import { getPermissions } from 'selectors/shellSelectors';

const Splitter = persist({
    storage: window.localStorage,
    key: 'monitoring-page.side-panel',
})(VerticalSplitView);

const styles: { [name: string]: React.CSSProperties } = {
    sidePanel: {
        display: 'flex',
        flexDirection: 'column',
    },
    dateSection: {
        flex: '0 0 auto',
    },
    splitter: {
        flex: '1 1 auto',
        position: 'relative',
    },
    fullHeightCameraTree: {
        position: 'absolute',
        width: '100%',
        height: '100%',
    },
};

const RawSidePanel = ({ canViewAlarms }: StateProps) =>
    <div
        id="monitoring-page-side-panel"
        style={ styles.sidePanel }
    >
        <div style={ styles.dateSection }>
            <DateSection/>
        </div>
        <div style={ styles.splitter }>
            { canViewAlarms &&
                <Splitter
                    defaultValue=".75"
                    min1={ 32 }
                    min2={ 32 }
                >
                    <CameraTreeSection/>
                    <AlarmListSection/>
                </Splitter>
            }
            { !canViewAlarms &&
                <CameraTreeSection
                    style={ styles.fullHeightCameraTree }
                />
            }
        </div>
    </div>
;

type StateProps = {
    canViewAlarms: boolean;
};

const mapStateToProps = (state: State) => ({
    canViewAlarms: !!getPermissions(state).viewAlarms,
});

export const SidePanel = compose<StateProps, {}>(
    connect<StateProps, {}, {}>(mapStateToProps),
)(RawSidePanel);



// WEBPACK FOOTER //
// ./src/ui/pages/monitoring/sidePanel/SidePanel.tsx